import apiWrapper, { extractApiData } from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'
import {
  type GetTagsParams,
  type EntityOut,
  type GetListOfNlListQsParams,
  type ListOut,
  type PagedList,
  type Tag,
} from 'Types/beListApi'

const endpoints = ((baseURL: string) => {
  return {
    getNlList: (idList: number) => `${baseURL}/api/list/${idList}`,
    getListOfNlList: (qs: GetListOfNlListQsParams) =>
      `${baseURL}/api/lists?${encodeParams(qs) as unknown as string}`,

    //  filters
    getEntitiesUsingFilter: (idFilter: number) =>
      `${baseURL}/api/filter/${idFilter}/entities`,

    // tags
    getTags: (qs: GetTagsParams) =>
      `${baseURL}/api/tags?${encodeParams(qs) as unknown as string}`,
  }
})(process.env.BELIST_URL as unknown as string)

export const beListApiGetNlList = async (idList: number): Promise<ListOut> => {
  return await apiWrapper({
    url: endpoints.getNlList(idList),
  }).then(extractApiData)
}

export const beListApiGetListOfNlList = async (
  qs: GetListOfNlListQsParams,
): Promise<PagedList<ListOut>> => {
  return await apiWrapper({
    url: endpoints.getListOfNlList(qs),
  }).then(extractApiData)
}

export const beListApiGetEntitiesUsingFilter = async (
  idFilter: number,
): Promise<EntityOut[]> => {
  return await apiWrapper({
    url: endpoints.getEntitiesUsingFilter(idFilter),
  }).then(extractApiData)
}

export const beListApiGetTags = async (
  params: GetTagsParams,
): Promise<PagedList<Tag>> => {
  return await apiWrapper({
    url: endpoints.getTags(params),
  }).then(extractApiData)
}
